const errorHandler = async (errorPayload, setErrors) => { // Renamed 'error' to 'errorPayload' for clarity
    let displayErrors = {};

    // --- CASE 1: Direct validation error payload (statuscode 212 from successful HTTP 200 response) ---
    // Changed 'errorPayload.statusCode' to 'errorPayload.statuscode'
    if (errorPayload && errorPayload.statuscode === 212 && errorPayload.errors) {
        for (const field in errorPayload.errors) {
            if (errorPayload.errors.hasOwnProperty(field)) {
                // Assuming errors[field] is an array and we want the first message
                displayErrors[field] = errorPayload.errors[field][0];
            }
        }
        displayErrors.general = errorPayload.message || 'Please check your input for validation errors.';
        setErrors(displayErrors);
        return; // Exit function after handling
    }

    // --- CASE 2: Axios/Fetch error object (from a catch block for non-2xx HTTP statuses) ---
    if (errorPayload.response) {
        const responseData = errorPayload.response.data;
        const httpStatus = errorPayload.response.status; // Get the actual HTTP status code (e.g., 400, 500)

        // If the backend sends a structured error even for non-212 HTTP statuses
        if (responseData && responseData.errors) {
            for (const field in responseData.errors) {
                if (responseData.errors.hasOwnProperty(field)) {
                    displayErrors[field] = responseData.errors[field][0];
                }
            }
            displayErrors.general = responseData.message || `An error occurred with the server response (HTTP ${httpStatus}).`;
            setErrors(displayErrors);
            return;
        } else {
            // Generic server error (e.g., HTTP 500, 404 with no custom error body)
            console.error("Server Error Response (Non-212, non-structured):", responseData);
            displayErrors.general = responseData.message || `An unexpected server error occurred (Status: ${httpStatus}).`;
            if (responseData.error) { // Check for common error properties in generic responses
                displayErrors.general += " Error: " + responseData.error;
            }
            setErrors(displayErrors);
            return;
        }
    } else if (errorPayload.request) {
        // Request was made but no response received (network error, server down)
        console.log('No response received:', errorPayload.request);
        setErrors({ general: 'No response from server. Please check your internet connection or server status.' });
        return;
    } else if (errorPayload.message) {
        // Something else happened while setting up the request (e.g., client-side JS error,
        // or a generic Axios error message not related to a response/request)
        console.log('Error setting up request or client-side error:', errorPayload.message);
        setErrors({ general: errorPayload.message });
        return;
    } else {
        // A truly unknown error structure
        console.log('An unknown error occurred:', errorPayload);
        setErrors({ general: 'An unexpected error occurred. Please try again.' });
        return;
    }
};

export default errorHandler;
